import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class MotivoDepuracion extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'motivo-depuracion/one', saveUrl: 'motivo-depuracion/save', backUrl: '/Catalogo/MotivosDepuracion' },
      new Form([
        Form.Field('text', 'motivo_depuracion_motivo', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'motivo_depuracion_nombre', 'Nombre', '', [Validators.required], 8),
      ], ['Guardar'], 'Motivo de Depuracion'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(MotivoDepuracion)
